<template>
  <nav
    id="menu-derek"
    class="menu-container"
    :class="{ 'is-not-home': $route.name != 'Home' }"
  >
    <div class="top-nav d-none d-md-flex">
      <div
        v-if="topbar"
        id="topbar-editable"
        style="width: 100%;"
        v-html="topbar.html"
      ></div>
      <div class="nav-segundo-nivel">
        <ul class="container-max-width">
          <li>
            <router-link
              :to="{ name: 'Returns' }"
              class="item-nav-segundo-nivel"
            >
              Devoluciones
            </router-link>
          </li>
          <li>
            <router-link
              :to="{ name: 'Tiendas' }"
              class="item-nav-segundo-nivel"
            >
              Encuentra una tienda
            </router-link>
          </li>
          <li>
            <router-link
              :to="{ name: 'FollowOrder' }"
              class="item-nav-segundo-nivel"
            >
              Rastrear pedido
            </router-link>
          </li>
          <li>
            <a href="https://portalpagos.derek.co" class="pagar-cuota">
              Paga tu cuota
            </a>
          </li>
        </ul>
      </div>
    </div>
    <div class="menu-desktop container-max-width">
      <div class="d-flex align-items-center h-100">
        <div
          class="d-flex d-md-none pe-3"
          @click="
            btnMenuMovil = !btnMenuMovil
            showOptionsUser = false
          "
        >
          <svg
            v-show="!btnMenuMovil"
            xmlns="http://www.w3.org/2000/svg"
            width="25"
            height="22.21"
            viewBox="0 0 25 22.21"
            class="logo_derek"
          >
            <path
              id="menu"
              d="M0,22.21v-2H25v2ZM0,12.105v-2H25v2ZM0,2V0H25V2Z"
            />
          </svg>
          <svg
            v-show="btnMenuMovil"
            xmlns="http://www.w3.org/2000/svg"
            width="25.675"
            height="25.622"
            viewBox="0 0 25.675 25.622"
            class="logo_derek"
          >
            <path
              id="menu"
              d="M16.052,16.241,4.693,27.578l-1.506-1.5,11.36-11.338L3.244,3.457,4.7,2.011,16,13.292,27.354,1.957l1.506,1.5L17.5,14.793l11.36,11.339-1.451,1.446Z"
              transform="translate(-3.187 -1.957)"
            />
          </svg>
        </div>
        <router-link
          :to="{ name: 'Home' }"
          style="color: transparent; position: relative;"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="100"
            height="26.237"
            viewBox="0 0 100 26.237"
            class="logo_derek"
            @click="
              showOptionsUser = false
              btnMenuMovil = false
            "
          >
            <g id="DEREK_" transform="translate(-26.5 -23.6)">
              <path
                id="Trazado_825754"
                data-name="Trazado 825754"
                d="M47.674,49.147H44.222V46.615A10.22,10.22,0,0,1,36.4,49.837c-5.293,0-9.9-3.8-9.9-9.551s4.6-9.551,9.9-9.551,5.524.69,7.825,2.992V23.6h3.452V49.032h0ZM37.2,47.42c4.028,0,7.02-2.647,7.02-7.135s-2.877-7.135-7.02-7.135-7.02,2.647-7.02,7.135,2.877,7.135,7.02,7.135"
                transform="translate(0 0)"
              />
              <path
                id="Trazado_825755"
                data-name="Trazado 825755"
                d="M66.938,40.272H50.367c.345,3.682,2.647,6.214,6.559,6.214S62.1,45.45,62.8,42.919h3.682c-.69,4.718-5.524,5.984-9.436,5.984C50.482,48.9,46.8,45.335,46.8,39.7s3.913-9.9,10.242-9.9,9.666,3.452,9.666,9.436v1.036h.23Zm-3.682-2.417c0-4.028-3.107-5.639-6.1-5.639a6.434,6.434,0,0,0-6.674,5.639Z"
                transform="translate(3.06 0.935)"
              />
              <path
                id="Trazado_825756"
                data-name="Trazado 825756"
                d="M66.515,34.458c0-1.381,0-2.647-.115-4.028h3.222c0,1.036.115,2.3.115,3.567h0c1.611-2.877,3.107-3.8,7.135-3.8h1.151v3.107a3.917,3.917,0,0,0-1.611-.23c-4.143,0-6.444,2.877-6.444,6.559v8.516H66.515V34.458Z"
                transform="translate(6.015 0.995)"
              />
              <path
                id="Trazado_825757"
                data-name="Trazado 825757"
                d="M96.838,40.272H80.267c.345,3.682,2.647,6.214,6.559,6.214S92,45.45,92.7,42.919h3.682c-.69,4.718-5.524,5.984-9.436,5.984C80.382,48.9,76.7,45.335,76.7,39.7s3.913-9.9,10.242-9.9,9.666,3.452,9.666,9.436v1.036h.23Zm-3.682-2.417c0-4.028-3.107-5.639-6.1-5.639a6.434,6.434,0,0,0-6.674,5.639H93.156Z"
                transform="translate(7.568 0.935)"
              />
              <path
                id="Trazado_825758"
                data-name="Trazado 825758"
                d="M96.4,23.6h3.567V38.675l9.321-7.25h5.063l-9.9,7.595,11.507,10.127h-5.178l-10.817-9.9v9.9H96.4Z"
                transform="translate(10.537 0)"
              />
            </g>
          </svg>
          <span style="position: absolute;">Derek</span>
        </router-link>
        <div v-if="menuDerek" class="d-none d-md-flex h-100">
          <div id="cant-menu" class="categorys-menu">
            <ul v-for="(item, index) in menuDerek" :key="index">
              <li
                @click="
                  clickMenu()
                  showOptionsUser = false
                "
              >
                <router-link
                  class="category-menu"
                  :class="item.destacado == 1 ? 'd-flex' : ''"
                  :style="
                    item.color_fondo
                      ? `background-color: ${item.color_fondo}; color: ${item.color_texto}; border-radius: 20px; padding: .3rem .5rem; border: none !important; font-family: 'PT Sans', sans-serif !important;`
                      : ''
                  "
                  :to="{
                    name: item.routerName,
                    params: {
                      category: item.slug,
                      nameCreative: `menu-${item.slug}`,
                      slot: `menu`,
                      id: `${item.slug}`,
                      name: `menu ${item.slug}`,
                    },
                  }"
                >
                  {{ item.descripcion }}
                  <img
                    v-if="item.destacado == 1"
                    class="novelity"
                    src="@/assets/icons/novelty-icon.svg"
                    :alt="item.descripcion"
                  />
                </router-link>
                <sub-menu-desktop
                  v-if="item.subMenu && !click"
                  :categorias-destacadas="
                    item.categorias_destacadas ? item.categorias_destacadas : []
                  "
                  :data-sub-menu="item.subMenu"
                  :category="item.slug"
                />
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="d-flex">
        <div
          class="d-none d-md-flex derek-lovely"
          style="border-left: 2px dotted white; border-right: 2px dotted white; cursor: pointer;"
        >
          <router-link
            class="my-auto"
            :to="{
              name: 'TiendaCategory',
              params: {
                category: 'lovely',
                nameCreative: `menu-lovely`,
                slot: `menu`,
                id: `lovely`,
                name: `menu lovely`,
              },
            }"
          >
            <img
              src="@/assets/icons/lovely.svg"
              style="min-width: 83px; min-height: 45px;"
              class="px-3"
              alt="Logo categoría lovely"
            />
          </router-link>
        </div>
        <button
          class="icons-menu"
          aria-label="Usuario"
          @click="
            showOptionsUser = !showOptionsUser
            btnMenuMovil = false
          "
        >
          <img
            v-if="dataUser"
            style="min-width: 26px;"
            src="@/assets/icons/user-icon-logged.svg"
            alt="boton de usuario logueado"
          />
          <img
            v-else
            style="min-width: 26px;"
            src="@/assets/icons/user-icon.svg"
            alt="boton de usuario login"
          />
        </button>
        <button
          id="search_doofinder"
          class="icons-menu"
          aria-label="Search"
          @click="
            clickSearch()
            btnMenuMovil = false
          "
        >
          <img
            style="min-width: 26px;"
            src="@/assets/icons/search-icon.svg"
            alt="boton de busqueda"
          />
        </button>
        <router-link class="my-auto" :to="{ name: 'PerfilFavorites' }">
          <button
            class="icons-menu"
            aria-label="Favoritos"
            @click="
              showOptionsUser = false
              btnMenuMovil = false
            "
          >
            <img
              style="min-width: 26px;"
              src="@/assets/icons/favorite-icon.svg"
              alt="boton de favoritos"
            />
            <span v-if="productWhislist.length > 0" class="tag-menu">{{
              productWhislist.length
            }}</span>
          </button>
        </router-link>
        <router-link class="my-auto" :to="{ name: 'MyBag' }">
          <button
            class="icons-menu"
            aria-label="Bolsa"
            @click="
              showOptionsUser = false
              btnMenuMovil = false
            "
          >
            <img
              style="min-height: 26px; min-width: 21px;"
              src="@/assets/icons/shopping-bag.svg"
              alt="boton de carrito"
            />
            <span
              v-if="productsCart && productsCart.length > 0"
              class="tag-menu"
              style="bottom: -.5rem"
              >{{ productsCart.length }}</span
            >
          </button>
        </router-link>
      </div>
    </div>
    <menu-movil
      v-if="menuDerek"
      class="movil-menu"
      :style="btnMenuMovil ? 'width: 100%; left: 0' : 'width: 0; left: -100%'"
      :data-menu="menuDerek"
      :open-menu="btnMenuMovil"
      @closeMenu="btnMenuMovil = $event"
    />
    <user-menu
      :show-options-user="showOptionsUser"
      @clickOut="showOptionsUser = $event"
    />
    <search-products />
  </nav>
</template>
<script>
import { mapState } from 'vuex'
import { GA4ViewPromotion } from '@/GA4/events'
import { sendFBQEvent } from '@/fbq'

import SubMenuDesktop from '@/components/Menu/SubMenuDesktop.vue'
import MenuMovil from '@/components/Menu/MenuMovil.vue'
import UserMenu from '@/components/Menu/Shortcuts/UserMenu.vue'
import SearchProducts from '@/components/Menu/SearchProducts.vue'

export default {
  name: 'MenuBase',
  components: { SubMenuDesktop, MenuMovil, UserMenu, SearchProducts },
  data() {
    return {
      btnMenuMovil: false,
      showOptionsUser: false,
      click: false,
      sendGA4Topbar: false,
    }
  },
  computed: {
    ...mapState('layouts', ['menuDerek', 'menuLayoutDerek', 'topbar']),
    ...mapState('user', ['dataUser']),
    ...mapState('products', ['productWhislist']),
    ...mapState('cart', ['productsCart']),
    ...mapState(['loaderDerek']),
  },
  watch: {
    async click() {
      this.validateTop()
    },
    async $route() {
      this.btnMenuMovil = false
      this.showOptionsUser = false
      this.validateTop()
    },
    async loaderDerek() {
      this.validateTop()
    },
    async showOptionsUser() {
      if (this.showOptionsUser) {
        await setTimeout(() => {
          var currentScrollPos = window.pageYOffset
          let userMenuDerek = document.getElementById('user-menu-derek')
          let modalUserMenuDerek = document.getElementById('modal-bg-derek')
          if (window.innerWidth > 768) {
            if (this.topbar) {
              if (
                window.scrollY >
                document.getElementById('topbar-editable').offsetHeight + 120
              ) {
                userMenuDerek ? (userMenuDerek.style.top = '70px') : ''
                modalUserMenuDerek
                  ? (modalUserMenuDerek.style.top = '70px')
                  : ''
              } else {
                userMenuDerek
                  ? (userMenuDerek.style.top = this.topbar
                      ? document.getElementById('topbar-editable')
                          .offsetHeight +
                        120 -
                        currentScrollPos +
                        'px'
                      : '120px')
                  : ''
                modalUserMenuDerek
                  ? (modalUserMenuDerek.style.top = this.topbar
                      ? document.getElementById('topbar-editable')
                          .offsetHeight +
                        120 -
                        currentScrollPos +
                        'px'
                      : '120px')
                  : ''
              }
            } else if (window.scrollY > 120) {
              userMenuDerek ? (userMenuDerek.style.top = '70px') : ''
              modalUserMenuDerek ? (modalUserMenuDerek.style.top = '70px') : ''
            } else {
              userMenuDerek
                ? (userMenuDerek.style.top = this.topbar
                    ? document.getElementById('topbar-editable').offsetHeight +
                      120 +
                      'px'
                    : '120px')
                : ''
              modalUserMenuDerek
                ? (modalUserMenuDerek.style.top = this.topbar
                    ? document.getElementById('topbar-editable').offsetHeight +
                      120 +
                      'px'
                    : '120px')
                : ''
            }
          } else {
            userMenuDerek ? (userMenuDerek.style.top = '70px') : ''
            modalUserMenuDerek ? (modalUserMenuDerek.style.top = '70px') : ''
          }
          userMenuDerek.style.display = 'block'
        }, 1)
      }
    },
    async topbar() {
      if (this.topbar && !this.sendGA4Topbar) {
        this.sendGA4Topbar = true
        const parser = new DOMParser()
        const doc = parser.parseFromString(this.topbar.html, 'text/html')
        const h2Content = doc.querySelector('h2').textContent
        GA4ViewPromotion({
          nameCreative: `topBar page ${this.topbar.id}`,
          slot: `topbar-page-${this.topbar.id}`,
          id: `topBar-${this.topbar.id}`,
          name: `${h2Content}`,
          items: [],
        })
      }
      this.validateTop()
    },
    async menuDerek() {
      await this.validateTop()
    },
  },
  mounted() {
    var prevScrollpos = window.pageYOffset
    window.document.onscroll = () => {
      var currentScrollPos = window.pageYOffset
      if (
        this.menuLayoutDerek == 'menu-base' &&
        document.getElementsByClassName('movil-menu')[0].style.left != '0px'
      ) {
        let navBar = document.getElementById('menu-derek')
        let filters = document.getElementById('nav-filters-desktop')
        // let filtersSidebar = document.getElementById("sidebar-menu-movil");
        // let size_guide_movil = document.getElementById("size-guide-product-detail-movil");
        // let size_guide_desktop = document.getElementById("size-guide-product-detail-desktop");
        let submenu_movil = document.getElementById('sub-menu-movil')
        let dataProduct = document.getElementById('id-product-detail-data')
        let userMenuDerek = document.getElementById('user-menu-derek')
        let modalUserMenuDerek = document.getElementById('modal-bg-derek')
        if (
          currentScrollPos < prevScrollpos &&
          !document.getElementById('user-menu-derek')
        ) {
          navBar.classList.add('isScrolleable')
          if (window.innerWidth > 768) {
            navBar.style.top = this.topbar ? '-100px' : '-50px'
            if (window.scrollY > 100) {
              userMenuDerek
                ? (userMenuDerek.style.transitionDuration = '.2s')
                : ''
              modalUserMenuDerek
                ? (modalUserMenuDerek.style.transitionDuration = '.2s')
                : ''
              userMenuDerek ? (userMenuDerek.style.top = '70px') : ''
              modalUserMenuDerek ? (modalUserMenuDerek.style.top = '70px') : ''
            } else {
              navBar.classList.remove('isScrolleable')
              userMenuDerek
                ? (userMenuDerek.style.transitionDuration = '0s')
                : ''
              modalUserMenuDerek
                ? (modalUserMenuDerek.style.transitionDuration = '0s')
                : ''
              userMenuDerek
                ? (userMenuDerek.style.top =
                    (this.topbar ? 70 : 50) + (100 - window.scrollY) + 'px')
                : ''
              modalUserMenuDerek
                ? (modalUserMenuDerek.style.top =
                    (this.topbar ? 70 : 50) + (100 - window.scrollY) + 'px')
                : ''
              navBar.style.top = '0px'
            }
          } else {
            document.getElementsByClassName(
              'movil-menu',
            )[0].style.paddingBottom = '70px'
            navBar.style.top = '0px'
            userMenuDerek
              ? (userMenuDerek.style.transitionDuration = '.2s')
              : ''
            modalUserMenuDerek
              ? (modalUserMenuDerek.style.transitionDuration = '.2s')
              : ''
            userMenuDerek ? (userMenuDerek.style.top = '70px') : ''
            modalUserMenuDerek ? (modalUserMenuDerek.style.top = '70px') : ''
            if (window.scrollY < 100) {
              navBar.classList.remove('isScrolleable')
            }
          }
          filters ? (filters.style.top = '69px') : ''
          // filtersSidebar ? filtersSidebar.style.top = '70px' : '';
          dataProduct ? (dataProduct.style.top = '70px') : ''
          // size_guide_movil ? size_guide_movil.style.top = '70px' : '';
          // size_guide_desktop ? size_guide_desktop.style.top = '70px' : '';
          submenu_movil ? (submenu_movil.style.top = '70px') : ''
          submenu_movil
            ? (submenu_movil.style.height = 'calc(100% - 70px)')
            : ''
        } else {
          navBar.classList.remove('isScrolleable')
          if (window.innerWidth > 768) {
            if (!userMenuDerek) {
              navBar.style.top = this.topbar ? '-170px' : '-120px'
            }
            if (window.scrollY > 100) {
              userMenuDerek
                ? (userMenuDerek.style.transitionDuration = '.2s')
                : ''
              modalUserMenuDerek
                ? (modalUserMenuDerek.style.transitionDuration = '.2s')
                : ''
              userMenuDerek ? (userMenuDerek.style.top = '70px') : ''
              modalUserMenuDerek ? (modalUserMenuDerek.style.top = '70px') : ''
            } else {
              userMenuDerek
                ? (userMenuDerek.style.transitionDuration = '0s')
                : ''
              modalUserMenuDerek
                ? (modalUserMenuDerek.style.transitionDuration = '0s')
                : ''
              userMenuDerek
                ? (userMenuDerek.style.top =
                    (this.topbar ? 70 : 50) + (100 - window.scrollY) + 'px')
                : ''
              modalUserMenuDerek
                ? (modalUserMenuDerek.style.top =
                    (this.topbar ? 70 : 50) + (100 - window.scrollY) + 'px')
                : ''
            }
          } else {
            userMenuDerek
              ? (userMenuDerek.style.transitionDuration = '.2s')
              : ''
            modalUserMenuDerek
              ? (modalUserMenuDerek.style.transitionDuration = '.2s')
              : ''
            if (window.scrollY > 10) {
              document.getElementsByClassName(
                'movil-menu',
              )[0].style.paddingBottom = '0px'
              navBar.style.top = '-70px'
              userMenuDerek ? (userMenuDerek.style.top = '0px') : ''
              modalUserMenuDerek ? (modalUserMenuDerek.style.top = '0px') : ''
            }
          }
          filters ? (filters.style.top = '0') : ''
          dataProduct ? (dataProduct.style.top = '0') : ''
          // filtersSidebar ? filtersSidebar.style.top = '0' : '';
          // size_guide_movil ? size_guide_movil.style.top = '0' : '';
          // size_guide_desktop ? size_guide_desktop.style.top = '0' : '';
          submenu_movil ? (submenu_movil.style.top = '0') : ''
          submenu_movil ? (submenu_movil.style.height = '100%') : ''
        }
        prevScrollpos = currentScrollPos
      }
    }
    this.validateTop()
  },
  methods: {
    async clickMenu() {
      this.click = true
      let elThis = this
      await setTimeout(function() {
        elThis.click = false
      }, 1000)
    },
    clickSearch() {
      this.showOptionsUser = false
      sendFBQEvent(this, 'Search', {})
    },
    async validateTop() {
      let submenu_desktop = document.querySelectorAll('.sub-menu-desktop')
      if (submenu_desktop.length > 0 && this.topbar) {
        submenu_desktop.forEach(element => {
          let heightTopbar = document.getElementById('topbar-editable')
          element.style.top =
            this.topbar && heightTopbar
              ? parseInt(heightTopbar.offsetHeight + 120) + 'px'
              : '120px'
        })
      } else {
        await setTimeout(() => this.validateTop(), 100)
      }
    },
  },
}
</script>
